(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EASE = 'cubic-bezier(0.85, 0, 0.15, 1)';

    class ContentBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.cursor = this.querySelector('.before-after__cursor');
        this.vertical = this.classList.contains('before-after__box--vertical');
        this.initial = Number(this.getAttribute('initial')) || 0;
        this.position = 0;
        this.onPointerDown = this.onPointerDown.bind(this);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.cursor.addEventListener('keydown', (event) => this.onKey(event));
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.observer.disconnect();
          this.intro();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      set(value) {
        this.position = Math.min(100, Math.max(0, value));
        this.style.setProperty('--before-after-position', `${this.position}%`);
        this.cursor.setAttribute('aria-valuenow', Math.round(this.position));
      }

      intro() {
        this.introduced = true;
        this.introAnimation = this.animate({ '--before-after-position': ['0%', `${this.initial}%`] }, { duration: 600, easing: EASE });
        this.introAnimation.finished.then(() => !this.moved && this.set(this.initial)).catch(() => {});
        this.set(this.initial);
      }

      stopIntro() {
        this.moved = true;
        this.observer?.disconnect();
        this.introAnimation?.cancel();
      }

      fromPointer(event) {
        const box = this.getBoundingClientRect();
        if (this.vertical) return ((event.clientY - box.top) / box.height) * 100;
        const x = ((event.clientX - box.left) / box.width) * 100;
        return getComputedStyle(this).direction === 'rtl' ? 100 - x : x;
      }

      onPointerDown(event) {
        if (event.button > 0 || event.target.closest('a[href]')) return;
        const onHandle = this.cursor.contains(event.target);
        if (event.pointerType === 'touch' && !onHandle) {
          /* A short tap jumps; anything longer (scroll, long press) is left to the browser. */
          const start = event.timeStamp;
          const up = (e) => {
            this.removeEventListener('pointerup', up);
            if (e.timeStamp - start <= 250) {
              this.stopIntro();
              this.set(this.fromPointer(e));
            }
          };
          this.addEventListener('pointerup', up);
          this.addEventListener('pointercancel', () => this.removeEventListener('pointerup', up), { once: true });
          return;
        }
        event.preventDefault();
        this.stopIntro();
        this.set(this.fromPointer(event));
        const move = (e) => this.set(this.fromPointer(e));
        const end = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', end);
          window.removeEventListener('pointercancel', end);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
      }

      onKey(event) {
        const keys = this.vertical ? { ArrowUp: -1, ArrowDown: 1 } : { ArrowLeft: -1, ArrowRight: 1 };
        const dir = keys[event.key];
        if (!dir) return;
        event.preventDefault();
        const base = this.introduced || this.moved ? Math.round(this.position) : this.initial;
        this.stopIntro();
        this.set(base + dir);
      }
    }

    customElements.get('before-after-slider') || customElements.define('before-after-slider', ContentBeforeAfter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Scroll progress through the section picks the active category in equal steps */
    class CategorySpotlight extends HTMLElement {
      connectedCallback() {
        this.images = [...this.querySelectorAll('.category-spotlight__image')];
        this.names = [...this.querySelectorAll('.category-spotlight__name')];
        this.button = this.querySelector('[data-spotlight-button]');
        this.index = 0;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        if (this.names.length > 1) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }
        this.addEventListener('shopify:block:select', (event) => {
          const name = event.target.querySelector?.('.category-spotlight__name');
          if (name) this.show(Number(name.dataset.index));
        });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset')) || 0;
        const travel = this.offsetHeight - this.querySelector('.category-spotlight__stage').offsetHeight;
        const progress = travel > 0 ? Math.min(Math.max((offset - this.getBoundingClientRect().top) / travel, 0), 1) : 0;
        this.show(Math.min(this.names.length - 1, Math.floor(progress * this.names.length)));
      }

      show(index) {
        if (index === this.index) return;
        this.index = index;
        this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
        this.names.forEach((name, i) => name.setAttribute('aria-current', String(i === index)));
        if (this.button) this.button.href = this.names[index].href;
      }
    }
    if (!customElements.get('category-spotlight')) customElements.define('category-spotlight', CategorySpotlight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class DynamicGrid extends HTMLElement {
      connectedCallback() {
        this.countRows();
        this.items = [...this.querySelectorAll('[data-grid-item]')].filter((i) => Number(i.dataset.parallaxSpeed));
        if (this.items.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.update = this.update.bind(this);
          addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
          addEventListener('resize', this.update);
          this.update();
        }
        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:section:select', () => this.classList.add('is-editing'));
          this.addEventListener('shopify:section:deselect', () => this.classList.remove('is-editing'));
          this.addEventListener('shopify:block:select', (e) => {
            this.classList.add('is-editing');
            this.querySelectorAll('[data-grid-item]').forEach((i) => i.classList.toggle('is-selected', i.contains(e.target)));
          });
          this.addEventListener('shopify:block:deselect', () => this.querySelectorAll('[data-grid-item]').forEach((i) => i.classList.remove('is-selected')));
        }
      }

      // The grid has as many fixed rows as the lowest "start at row" of its visible items. Theme blocks expose no
      // settings to the section's Liquid, so the count is read from the items' own row values here.
      countRows() {
        const items = [...this.querySelectorAll('[data-grid-item]')];
        const rows = (key, hidden) => Math.max(1, ...items.filter((i) => i.dataset.visibility !== hidden).map((i) => Number(i.style.getPropertyValue(key)) || 1));
        this.style.setProperty('--rows-mobile', rows('--mobile-row', 'desktop_only'));
        this.style.setProperty('--rows-desktop', rows('--desktop-row', 'mobile_only'));
      }

      update() {
        const grid = this.querySelector('.dynamic-grid__grid');
        const rect = grid.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (innerHeight - rect.top) / (innerHeight + rect.height)));
        const vmin = Math.min(innerWidth, innerHeight) / 100;
        this.items.forEach((item) => {
          const amplitude = Number(item.dataset.parallaxSpeed) * 5 * vmin;
          const offset = -amplitude + 2 * amplitude * progress;
          item.style.transform = item.dataset.parallaxDirection === 'horizontal' ? `translateX(${offset}px)` : `translateY(${offset}px)`;
        });
      }
    }
    customElements.get('dynamic-grid') || customElements.define('dynamic-grid', DynamicGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const USER_INPUT = ['wheel', 'touchstart', 'keydown'];

    class ContentFaq extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-toc-link]')];
        if (this.links.length) {
          this.headings = [...this.querySelectorAll('[data-category]')];
          this.links.forEach((link) => link.addEventListener('click', (event) => this.jump(event, link)));
          this.onScroll = () => {
            this.frame ||= requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          // A clicked category stays highlighted until the shopper moves the page themselves.
          this.release = () => (this.pinned = null);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          USER_INPUT.forEach((type) => window.addEventListener(type, this.release, { passive: true }));
          this.update();
        }
        if (window.Shopify?.designMode) {
          this.onSelect = (event) => this.toggleBlock(event, true);
          this.onDeselect = (event) => this.toggleBlock(event, false);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          USER_INPUT.forEach((type) => window.removeEventListener(type, this.release));
        }
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      update() {
        if (this.pinned) return this.activate(this.pinned);
        const line = window.innerHeight * 0.3;
        const current = this.headings.findLast((heading) => heading.getBoundingClientRect().top <= line) || this.headings[0];
        if (current) this.activate(current.id);
      }

      activate(id) {
        this.links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${id}`));
      }

      jump(event, link) {
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;
        event.preventDefault();
        this.pinned = target.id;
        this.activate(target.id);
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }

      toggleBlock(event, open) {
        if (!this.contains(event.target)) return;
        const accordion = event.target.querySelector('x-accordion');
        const details = accordion?.querySelector('details');
        if (!details || details.open === open) return;
        if (open && event.detail?.load) return void (details.open = true);
        if (typeof accordion.open === 'function' && !matchMedia('(prefers-reduced-motion: reduce)').matches) open ? accordion.open() : accordion.close();
        else details.open = open;
      }
    }

    customElements.get('faq-navigation') || customElements.define('faq-navigation', ContentFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class FeaturedCollections extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.slots = [...this.querySelectorAll('[data-link-slot]')];
        this.index = 0;
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(Number(tab.dataset.tab))));
        if (this.panels.length > 1) {
          this.querySelector('.featured-collections__panels').addEventListener('keydown', (e) => {
            if (e.target !== e.currentTarget) return;
            if (e.key === 'ArrowLeft') this.select((this.index - 1 + this.panels.length) % this.panels.length);
            if (e.key === 'ArrowRight') this.select((this.index + 1) % this.panels.length);
          });
        }
        this.addEventListener('shopify:block:select', (e) => {
          const tab = e.target.closest('[data-tab]');
          if (tab) this.select(Number(tab.dataset.tab), e.detail?.load);
        });
        new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.panels[0]?.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        }).observe(this);
      }

      async select(index, instant = false) {
        if (index === this.index) return;
        const from = this.panels[this.index];
        const to = this.panels[index];
        this.index = index;
        const reduced = instant || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tabs.forEach((t, i) => t.setAttribute('aria-selected', String(i === index)));
        const tab = this.tabs[index];
        const row = tab?.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: tab.offsetLeft - row.clientWidth / 2 + tab.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' });
        const n = this.panels.length;
        [index - 1, index, index + 1].forEach((i) => this.panels[(i + n) % n].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager')));
        if (!reduced) await from.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(15px)' }], { duration: 300, easing: 'ease-in', fill: 'forwards' }).finished;
        from.hidden = true;
        from.getAnimations().forEach((a) => a.cancel());
        to.hidden = false;
        to.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
        this.slots.forEach((slot, i) => (slot.hidden = i !== index));
        if (!reduced) to.animate([{ opacity: 0, transform: 'translateY(15px)' }, { opacity: 1, transform: 'none' }], { duration: 200, delay: 200, easing: 'ease-out', fill: 'backwards' });
      }
    }
    customElements.get('featured-collections') || customElements.define('featured-collections', FeaturedCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-with-text-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktop = matchMedia('(min-width: 1000px)');
    class ImagesScroll extends HTMLElement {
      connectedCallback() {
        this.images = [...this.querySelectorAll('[data-image]')];
        this.texts = [...this.querySelectorAll('[data-text]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.onScroll = this.onScroll.bind(this);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
        if (this.texts.length > 1) {
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.go(this.index - 1);
            if (e.key === 'ArrowRight') this.go(this.index + 1);
          });
          if (!desktop.matches) this.setupSwipe();
        }
        new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        }).observe(this);
        desktop.addEventListener('change', () => this.setMode());
        this.setMode();
      }

      setMode() {
        window.removeEventListener('scroll', this.onScroll);
        this.images.forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
        this.texts.forEach((el) => {
          el.getAnimations().forEach((a) => a.cancel());
          el.style.opacity = '';
        });
        if (desktop.matches) {
          this.current = -1;
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        } else {
          this.images.forEach((el, i) => el.classList.toggle('is-selected', i === this.index));
          this.texts.forEach((el, i) => el.classList.toggle('is-selected', i === this.index));
        }
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const rect = this.getBoundingClientRect();
          const mid = innerHeight / 2;
          const progress = Math.min(0.9999, Math.max(0, (mid - rect.top) / rect.height));
          const segment = Math.floor(progress * this.texts.length);
          let target = segment;
          while (target > 0 && !this.images[target].querySelector('img, svg')) target--;
          if (target !== this.current) {
            this.current = target;
            this.images.forEach((el, i) => el.classList.toggle('is-current', i === target));
          }
          this.texts.forEach((text) => {
            const r = text.getBoundingClientRect();
            const p = (innerHeight - r.top) / (innerHeight + r.height);
            const stops = [0, 0.25, 1, 0.25, 0];
            const x = Math.min(1, Math.max(0, p)) * 4;
            const i = Math.min(3, Math.floor(x));
            text.style.opacity = (stops[i] + (stops[i + 1] - stops[i]) * (x - i)).toFixed(3);
          });
        });
      }

      async go(target) {
        const count = this.texts.length;
        const next = ((target % count) + count) % count;
        if (next === this.index) return;
        const fromText = this.texts[this.index];
        const toText = this.texts[next];
        const fromImage = this.images[this.index];
        const toImage = this.images[next];
        this.index = next;
        this.dots.forEach((d, i) => d.setAttribute('aria-current', String(i === next)));
        [next - 1, next + 1].forEach((i) => this.images[(i + count) % count].querySelectorAll('img').forEach((img) => (img.loading = 'eager')));
        const instant = reduced();
        if (!instant) await fromText.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-15px)' }], { duration: 400, easing: 'cubic-bezier(.55,.055,.675,.19)', fill: 'forwards' }).finished;
        fromText.classList.remove('is-selected');
        fromText.getAnimations().forEach((a) => a.cancel());
        const swap = toImage.querySelector('img, svg') && toImage !== fromImage;
        toImage.classList.add('is-selected');
        if (!instant) {
          fromImage.animate({ opacity: [1, 0] }, { duration: 800, easing: 'ease', fill: 'forwards' }).finished.then(() => {
            if (fromImage !== this.images[this.index]) fromImage.classList.remove('is-selected');
            fromImage.getAnimations().forEach((a) => a.cancel());
          });
          if (swap) toImage.animate({ opacity: [0, 1] }, { duration: 800, easing: 'ease' });
          setTimeout(() => {
            toText.classList.add('is-selected');
            toText.animate([{ opacity: 0, transform: 'translateY(15px)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: 'cubic-bezier(.25,.46,.45,.94)' });
          }, 400);
        } else {
          fromImage.classList.remove('is-selected');
          toText.classList.add('is-selected');
        }
      }

      setupSwipe() {
        let start = null;
        this.addEventListener('pointerdown', (e) => (start = { x: e.clientX, y: e.clientY, t: Date.now() }));
        this.addEventListener('pointerup', (e) => {
          if (!start) return;
          const dx = e.clientX - start.x;
          if (Math.abs(dx) > 80 && Math.abs(e.clientY - start.y) < 80 && Date.now() - start.t < 500) this.go(this.index + (dx < 0 ? 1 : -1));
          start = null;
        });
      }
    }
    customElements.get('images-scroll') || customElements.define('images-scroll', ImagesScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    class ArticleSection extends HTMLElement {
      connectedCallback() {
        this.toolbar = this.querySelector('[data-toolbar]');
        this.image = this.querySelector('.main-article__image--parallax img');
        this.onScroll = () => requestAnimationFrame(() => this.update());
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const rect = this.getBoundingClientRect();
        if (this.toolbar) this.toolbar.classList.toggle('is-visible', rect.top < -100 && rect.bottom > 0);
        if (this.image && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const frame = this.image.parentElement.getBoundingClientRect();
          const first = this.closest('.shopify-section') === document.querySelector('main .shopify-section');
          const start = first ? frame.top + window.scrollY : window.innerHeight;
          const travel = first ? frame.height + frame.top + window.scrollY : window.innerHeight + frame.height;
          const progress = Math.min(1, Math.max(0, first ? window.scrollY / travel : (start - frame.top) / travel));
          this.image.style.translate = `0 ${(-11.54 + 23.08 * progress).toFixed(2)}%`;
        }
      }
    }

    customElements.get('article-section') || customElements.define('article-section', ArticleSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-account"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const row = event.target.closest('.account-orders__table tr[data-href]');
    if (!row || event.target.closest('a, button')) return;
    window.location.href = row.dataset.href;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-addresses"]) return;
  try {
    
  (() => {
    const setupAddressForms = (root = document) => {
      root.querySelectorAll('[data-address-form]').forEach((form) => {
        if (form._ready) return;
        form._ready = true;
        const country = form.querySelector('[data-country-select]');
        const province = form.querySelector('[data-province-select]');
        const wrapper = form.querySelector('[data-province-wrapper]');
        if (!country || !province) return;

        const savedCountry = country.dataset.default;
        const match = savedCountry && [...country.options].find((option) => option.value === savedCountry || option.textContent.trim() === savedCountry);
        if (match) country.value = match.value;
        else country.selectedIndex = 0;

        const update = (initial) => {
          let provinces = [];
          try {
            provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
          } catch (error) {}
          province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
          wrapper.hidden = provinces.length === 0;
          if (initial && (province.dataset.default || province.dataset.defaultCode)) {
            const saved = [province.dataset.default, province.dataset.defaultCode].filter(Boolean);
            const found = provinces.find(([value, label]) => saved.includes(value) || saved.includes(label));
            if (found) province.value = found[0];
          }
        };
        update(true);
        country.addEventListener('change', () => update(false));
      });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-delete-address]');
      if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAddressForms());
    else setupAddressForms();
    document.addEventListener('shopify:section:load', (event) => setupAddressForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-login"]) return;
  try {
    
  customElements.get('account-login') || customElements.define('account-login', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panels = {
        login: this.querySelector('[data-panel="login"]'),
        recover: this.querySelector('[data-panel="recover"]'),
      };
      const initial = this.dataset.initial || (location.hash === '#recover' ? 'recover' : 'login');
      if (this.dataset.initial) history.replaceState(null, '', `${location.pathname}${location.search}${initial === 'recover' ? '#recover' : ''}`);
      this.show(initial, false);
      this.onHashChange = () => this.show(location.hash === '#recover' ? 'recover' : 'login', true);
      window.addEventListener('hashchange', this.onHashChange);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHashChange);
    }

    async show(name, animate) {
      const next = this.panels[name];
      const current = Object.values(this.panels).find((panel) => panel !== next && !panel.hidden);
      if (!next || !current) return;
      const token = (this._token = {});
      const duration = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 600 : 0;
      if (duration) {
        await current.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(30px)' }], { duration, easing: 'ease' }).finished.catch(() => {});
        if (token !== this._token) return;
      }
      current.hidden = true;
      next.hidden = false;
      if (duration) next.animate([{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration, easing: 'ease' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
  customElements.get('gift-card-qr') || customElements.define('gift-card-qr', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const draw = () => {
        if (!window.QRCode || this.childElementCount) return;
        new window.QRCode(this, { text: this.dataset.identifier, width: 80, height: 80 });
      };
      if (window.QRCode) draw();
      else window.addEventListener('load', draw, { once: true });
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-print]')) return window.print();
    if (event.target.matches('[data-select-all]')) return event.target.select();
    const button = event.target.closest('[data-copy-code]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.dataset.copyCode).then(() => {
      button._label = button._label || button.textContent;
      button.textContent = button.dataset.copiedLabel;
      window.Theme?.announce?.(button.dataset.copiedLabel);
      clearTimeout(button._timer);
      button._timer = setTimeout(() => (button.textContent = button._label), 1500);
    }).catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  /* A failed store password submission reopens the drawer on load */
  (() => {
    const openFailedForms = () => {
      document.querySelectorAll('.password-drawer').forEach((dialog) => {
        if (!dialog.querySelector('[data-password-error]')) return;
        customElements.whenDefined('x-dialog').then(() => requestAnimationFrame(() => dialog.show?.()));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFailedForms);
    else openFailedForms();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Videos load nothing until they near the screen, then play; off screen they pause */
    class MediaCarousel extends HTMLElement {
      connectedCallback() {
        const videos = [...this.querySelectorAll('video[data-lazy-video]')];
        if (!videos.length) return;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) {
              target.preload = 'auto';
              target.play().catch(() => {});
            } else {
              target.pause();
            }
          });
        }, { rootMargin: '200px' });
        videos.forEach((video) => this.observer.observe(video));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
    if (!customElements.get('media-carousel')) customElements.define('media-carousel', MediaCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MediaTile extends HTMLElement {
      connectedCallback() {
        const play = this.querySelector('[data-play]');
        if (play) {
          play.addEventListener('click', (e) => {
            e.preventDefault();
            const video = this.querySelector('video');
            video?.play();
            play.hidden = true;
            this.classList.add('media-tile--playing');
          });
        }
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return this.classList.add('is-revealed');
        new IntersectionObserver(async (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          const img = this.querySelector('img');
          if (img && !img.complete) await new Promise((r) => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); });
          this.classList.add('is-revealed');
          this.animate({ opacity: [0, 1] }, { duration: 350, easing: 'ease' });
        }, { rootMargin: '-200px 0px 0px 0px' }).observe(this);
      }
    }
    customElements.get('media-tile') || customElements.define('media-tile', MediaTile);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ContentColumns extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode) return;
        this.onBlockSelect = (event) => {
          const column = event.target;
          if (!this.contains(column) || column.parentElement !== this) return;
          const behavior = event.detail?.load || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          const delta = column.getBoundingClientRect().left + column.offsetWidth / 2 - (this.getBoundingClientRect().left + this.clientWidth / 2);
          if (this.scrollWidth > this.clientWidth) this.scrollBy({ left: delta, behavior });
          const box = column.getBoundingClientRect();
          const dy = box.top < 0 ? box.top : box.bottom > innerHeight ? Math.min(box.bottom - innerHeight, box.top) : 0;
          if (dy) window.scrollBy({ top: dy, behavior });
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    customElements.get('multi-column-slider') || customElements.define('multi-column-slider', ContentColumns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-media-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MultiMediaReveal extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-reveal-media')) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return this.classList.add('is-revealed');
        const finish = (instant) => {
          this.classList.add('is-revealed');
          const items = this.querySelectorAll('[data-media-item]');
          const text = this.querySelector('[data-media-text]');
          items.forEach((item) => {
            const rotation = getComputedStyle(item).getPropertyValue('--rotation').trim() || '0deg';
            item.animate([{ opacity: 0, rotate: '0deg' }, { opacity: 1, rotate: rotation }], { duration: instant ? 0 : 500, easing: 'ease', fill: 'forwards' });
          });
          text?.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: instant ? 0 : 500, delay: instant ? 0 : 500, easing: 'ease', fill: 'backwards' });
        };
        if (window.Shopify?.designMode && this.closest('.shopify-section')?.dataset.reloaded) return finish(true);
        new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          finish(false);
        }, { rootMargin: '-10% 0px -10% 0px' }).observe(this);
      }
    }
    customElements.get('multi-media-reveal') || customElements.define('multi-media-reveal', MultiMediaReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-carousel')) {
    // Opens the review popup on the clicked card. Clicks that end a drag are ignored so swiping never opens it.
    customElements.define('review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        let start, dragged = false;

        this.addEventListener('pointerdown', (event) => {
          start = { x: event.clientX, y: event.clientY };
          dragged = false;
        }, options);
        this.addEventListener('pointermove', (event) => {
          if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 8) dragged = true;
        }, options);
        this.addEventListener('pointerup', () => { start = null; }, options);
        this.addEventListener('pointercancel', () => { start = null; dragged = true; }, options);

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('.po-reviews__open');
          if (!trigger) return;
          if (event.detail > 0 && (dragged || event.defaultPrevented)) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          const modal = document.getElementById(trigger.getAttribute('aria-controls'));
          const carousel = modal.querySelector('x-carousel');
          const index = Number(trigger.dataset.reviewIndex);

          // Jump to the clicked review as soon as the popup is open.
          modal.addEventListener('dialog:show', () => {
            requestAnimationFrame(() => carousel.select(index, 'auto'));
          }, { once: true, signal: this.controller.signal });
        }, options);
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ContentMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.scrolling-content__track');
        this.row = this.querySelector('[data-row]');
        if (!this.row?.children.length) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.observer.disconnect();
          this.start();
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this);
        if (this.hasAttribute('pause-on-hover')) {
          const host = this.closest('.scrolling-content') || this;
          host.addEventListener('pointerenter', () => this.animation?.pause());
          host.addEventListener('pointerleave', () => this.animation?.play());
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.animation?.cancel();
      }

      start() {
        /* Reduced motion: the line stays still (the design system stops marquees). */
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.build();
        let lastWidth = this.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          if (Math.abs(this.clientWidth - lastWidth) < 1) return;
          lastWidth = this.clientWidth;
          this.build();
        });
        this.resizeObserver.observe(this);
      }

      build() {
        this.track.querySelectorAll('[data-copy]').forEach((copy) => copy.remove());
        this.animation?.cancel();
        const rowWidth = this.row.getBoundingClientRect().width;
        const width = this.clientWidth;
        if (!rowWidth) return;
        const copies = Math.ceil(width / rowWidth);
        for (let k = 0; k < copies; k++) {
          [this.row.cloneNode(true), this.row.cloneNode(true)].forEach((copy, i) => {
            copy.setAttribute('data-copy', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-row');
            copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
            i === 0 ? this.track.prepend(copy) : this.track.append(copy);
          });
        }
        const rtl = getComputedStyle(this).direction === 'rtl';
        const toLeft = (this.getAttribute('direction') !== 'right') !== rtl;
        /* The original row sits after `copies` copies; moving right, it is anchored to the end edge. */
        const base = -copies * rowWidth + (toLeft ? 0 : width - rowWidth);
        const end = base + (toLeft ? -rowWidth : rowWidth);
        const speed = 300 * (Number(this.getAttribute('speed')) || 0.3);
        this.animation = this.track.animate(
          [{ transform: `translateX(${base}px)` }, { transform: `translateX(${end}px)` }],
          { duration: (rowWidth / speed) * 1000, iterations: Infinity, easing: 'linear' }
        );
      }
    }

    customElements.get('scrolling-marquee') || customElements.define('scrolling-marquee', ContentMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktop = matchMedia('(min-width: 1000px)');
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.looks = [...this.querySelectorAll('[data-looks] > .shop-look__look')];
        this.lookIndex = 0;
        this.querySelector('[data-look-prev]')?.addEventListener('click', () => this.goLook(this.lookIndex - 1));
        this.querySelector('[data-look-next]')?.addEventListener('click', () => this.goLook(this.lookIndex + 1));
        this.querySelectorAll('[data-look-dot]').forEach((d) => d.addEventListener('click', () => this.goLook(Number(d.dataset.lookDot))));
        this.querySelector('[data-looks]')?.addEventListener('keydown', (e) => {
          if (e.target !== e.currentTarget) return;
          if (e.key === 'ArrowLeft') this.goLook(this.lookIndex - 1);
          if (e.key === 'ArrowRight') this.goLook(this.lookIndex + 1);
        });
        this.looks.forEach((look) => this.setupLook(look));
        this.setupMobile();
        this.addEventListener('shopify:block:select', (e) => {
          const look = e.target.closest('[data-looks] > .shop-look__look');
          if (look) this.goLook(this.looks.indexOf(look), e.detail?.load);
        });
        new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          const content = this.looks[0]?.querySelector('[data-look-content]');
          if (content && !reduced()) content.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'ease' });
        }).observe(this);
      }

      setupLook(look) {
        look.productIndex = 0;
        const products = () => [...look.querySelectorAll('[data-look-products] > [data-product-slot]')];
        const select = (i) => {
          const list = products();
          const next = ((i % list.length) + list.length) % list.length;
          if (next === look.productIndex) return;
          const from = list[look.productIndex];
          const to = list[next];
          look.productIndex = next;
          look.querySelectorAll('[data-hotspot]').forEach((h, k) => h.setAttribute('aria-current', String(k === next)));
          look.querySelectorAll('[data-product-dot]').forEach((h, k) => h.setAttribute('aria-current', String(k === next)));
          to.classList.add('is-selected');
          if (!reduced()) {
            to.animate({ opacity: [0, 1] }, { duration: 300, easing: 'ease' });
            from.animate({ opacity: [1, 0] }, { duration: 300, easing: 'ease' }).finished.then(() => from.classList.remove('is-selected'));
          } else from.classList.remove('is-selected');
          const button = look.querySelector('[data-view-product]');
          if (button && to.dataset.url) button.href = to.dataset.url;
        };
        look.select = select;
        look.querySelectorAll('[data-hotspot]').forEach((h, k) => h.addEventListener('click', () => select(k)));
        look.querySelectorAll('[data-product-dot]').forEach((h, k) => h.addEventListener('click', () => select(k)));
        look.querySelector('[data-look-products]')?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') select(look.productIndex - 1);
          if (e.key === 'ArrowRight') select(look.productIndex + 1);
        });
      }

      goLook(target, instant = false) {
        const n = this.looks.length;
        if (n < 2) return;
        const next = ((target % n) + n) % n;
        if (next === this.lookIndex) return;
        const from = this.looks[this.lookIndex];
        const to = this.looks[next];
        this.lookIndex = next;
        this.querySelectorAll('[data-look-dot]').forEach((d, i) => d.setAttribute('aria-current', String(i === next)));
        [next - 1, next, next + 1].forEach((i) => this.looks[(i + n) % n].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager')));
        to.classList.add('is-selected');
        if (instant || reduced()) {
          from.classList.remove('is-selected');
          return;
        }
        const q = (el, sel) => el.querySelector(sel);
        q(from, '[data-look-content]')?.animate({ opacity: [1, 0] }, { duration: 300, easing: 'ease', fill: 'forwards' });
        q(from, '[data-look-media]')?.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(-15px)' }], { duration: 500, easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)', fill: 'forwards' });
        q(to, '[data-look-media]')?.animate([{ opacity: 0, transform: 'translateX(-15px)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'ease' });
        q(to, '[data-look-content]')?.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 500, delay: 400, easing: 'ease', fill: 'backwards' });
        setTimeout(() => {
          if (this.looks[this.lookIndex] === from) return;
          from.classList.remove('is-selected');
          from.getAnimations({ subtree: true }).forEach((a) => a.cancel());
        }, 900);
      }

      /* Phone and tablet: bottom sheet with zoom-to-look */
      setupMobile() {
        this.track = this.querySelector('[data-mobile-track]');
        this.cover = this.querySelector('[data-cover]');
        if (!this.track) return;
        const currentLook = () => Math.round(this.track.scrollLeft / (this.track.firstElementChild?.offsetWidth + 10 || 1));
        this.querySelector('[data-open-sheet]')?.addEventListener('click', () => this.openSheet(currentLook(), 0));
        this.track.querySelectorAll('.shop-look__look').forEach((look, li) => {
          look.querySelectorAll('[data-hotspot]').forEach((h, k) =>
            h.addEventListener('click', () => (this.openIndex === li ? this.moveSheet(k) : this.openSheet(li, k)))
          );
        });
        this.querySelectorAll('[data-close-sheet]').forEach((b) => b.addEventListener('click', () => this.closeSheet()));
        this.onKey = (e) => e.key === 'Escape' && this.closeSheet();
        this.querySelectorAll('[data-sheet-track]').forEach((t) =>
          t.addEventListener('scroll', () => {
            if (this.openIndex == null) return;
            const k = Math.round(t.scrollLeft / t.clientWidth);
            this.highlight(k);
          }, { passive: true })
        );
      }

      highlight(k) {
        const look = this.track.children[this.openIndex];
        look?.querySelectorAll('[data-hotspot]').forEach((h, i) => h.setAttribute('aria-current', String(i === k)));
        this.reframe(k);
      }

      openSheet(lookIndex, productIndex) {
        if (desktop.matches) return;
        this.openIndex = lookIndex;
        this.sheet = this.querySelector(`[data-sheet="${lookIndex}"]`);
        if (!this.sheet) return;
        this.sheet.hidden = false;
        document.documentElement.classList.add('shop-look-open');
        window.Theme?.lockScroll?.(this);
        this.classList.add('is-zoomed');
        requestAnimationFrame(() => {
          this.sheet.classList.add('is-open');
          this.moveSheet(productIndex, true);
          this.sheet.focus({ preventScroll: true });
        });
        document.addEventListener('keydown', this.onKey);
      }

      moveSheet(k, instant = false) {
        const t = this.sheet?.querySelector('[data-sheet-track]');
        if (!t) return;
        t.scrollTo({ left: k * t.clientWidth, behavior: instant || reduced() ? 'auto' : 'smooth' });
        this.highlight(k);
      }

      reframe(k) {
        const look = this.track.children[this.openIndex];
        const hotspot = look?.querySelectorAll('[data-hotspot]')[k];
        const media = look?.querySelector('[data-look-media]');
        if (!hotspot || !media || !this.sheet) return;
        // Untransformed geometry (layout offsets ignore transforms)
        const rect = this.track.getBoundingClientRect();
        const baseLeft = rect.left - (this._tx || 0);
        const baseTop = rect.top - (this._ty || 0);
        const mx = look.offsetLeft - this.track.scrollLeft + media.offsetLeft;
        const my = look.offsetTop + media.offsetTop;
        const mw = media.offsetWidth;
        const mh = media.offsetHeight;
        const scale = innerWidth / mw;
        const hy = (parseFloat(hotspot.style.top) / 100) * mh;
        const sheetTop = innerHeight - this.sheet.offsetHeight;
        const tx = -baseLeft - scale * mx;
        let imageTop = sheetTop / 2 - scale * hy;
        imageTop = Math.min(0, Math.max(sheetTop - scale * mh, imageTop));
        const ty = imageTop - baseTop - scale * my;
        this._tx = tx;
        this._ty = ty;
        this.track.style.transition = this._reframing && !reduced() ? 'transform 0.4s ease-in-out' : '';
        this.track.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
        this._reframing = true;
      }

      closeSheet() {
        if (this.openIndex == null) return;
        this.openIndex = null;
        this.sheet?.classList.remove('is-open');
        const sheet = this.sheet;
        setTimeout(() => (sheet.hidden = true), 300);
        this.track.style.transition = '';
        this.track.style.transform = '';
        this._tx = 0;
        this._ty = 0;
        this._reframing = false;
        this.classList.remove('is-zoomed');
        document.documentElement.classList.remove('shop-look-open');
        window.Theme?.unlockScroll?.(this);
        document.removeEventListener('keydown', this.onKey);
      }
    }
    customElements.get('shop-the-look') || customElements.define('shop-the-look', ShopTheLook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const OUT_EASE = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

    class ContentTimeline extends HTMLElement {
      connectedCallback() {
        this.slides = this.querySelector('.timeline__slides');
        this.items = [...this.querySelectorAll('[data-item]')];
        this.buttons = [...this.querySelectorAll('.timeline__nav-button')];
        this.nav = this.querySelector('.timeline__nav');
        this.index = 0;
        this.buttons.forEach((button, i) => button.addEventListener('click', () => this.select(i)));
        if (this.items.length > 1) {
          this.slides.addEventListener('keydown', (event) => {
            if (event.target !== this.slides) return;
            const dir = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
            if (!dir) return;
            event.preventDefault();
            this.select(this.index + dir);
          });
        }
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.observer.disconnect();
          this.preload();
          this.reveal();
        });
        this.observer.observe(this);

        if (window.Shopify?.designMode) {
          this.onSectionSelect = (event) => event.detail?.load && event.target.contains(this) && this.reveal(true);
          this.onBlockSelect = (event) => {
            const item = event.target.closest?.('[data-item]');
            if (item && this.contains(item)) this.select(this.items.indexOf(item), event.detail?.load);
          };
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      reveal(instant = false) {
        if (this.classList.contains('is-revealed')) return;
        this.classList.add('is-revealed');
        if (instant || reduced()) return;
        this.items[this.index].querySelector('[data-text]')?.animate(
          [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
          { duration: 500, easing: 'ease', fill: 'backwards' }
        );
      }

      preload() {
        const count = this.items.length;
        [this.index - 1, this.index + 1].forEach((i) => {
          this.items[(i + count) % count].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        });
      }

      select(index, instant = false) {
        const count = this.items.length;
        if (count < 2) return;
        index = (index + count) % count;
        if (index === this.index) return;
        const from = this.items[this.index];
        const to = this.items[index];
        this.index = index;
        this.classList.add('is-revealed');

        this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
        this.centerNav();
        this.preload();

        this.items.forEach((item) => {
          item.querySelectorAll('[data-image], [data-text]').forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
          item.classList.remove('is-leaving');
          item.classList.toggle('is-selected', item === to);
          item.toggleAttribute('inert', item !== to);
          item === to ? item.removeAttribute('aria-hidden') : item.setAttribute('aria-hidden', 'true');
        });
        clearTimeout(this.leaveTimer);
        if (instant || reduced()) return;

        from.classList.add('is-leaving');
        const fromText = from.querySelector('[data-text]');
        const fromImage = from.querySelector('[data-image]');
        fromText.animate({ opacity: [1, 0] }, { duration: 300, easing: 'ease', fill: 'forwards' });
        fromImage.animate({ opacity: [1, 0], transform: ['translateX(0)', 'translateX(-15px)'] }, { duration: 500, easing: OUT_EASE, fill: 'forwards' });
        to.querySelector('[data-image]').animate({ opacity: [0, 1], transform: ['translateX(15px)', 'translateX(0)'] }, { duration: 500, easing: 'ease', fill: 'backwards' });
        to.querySelector('[data-text]').animate({ opacity: [0, 1], transform: ['translateY(10px)', 'none'] }, { duration: 500, delay: 400, easing: 'ease', fill: 'backwards' });
        this.leaveTimer = setTimeout(() => {
          from.classList.remove('is-leaving');
          [fromText, fromImage].forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
        }, 900);
      }

      centerNav() {
        if (matchMedia('(min-width: 700px)').matches || this.nav.scrollWidth <= this.nav.clientWidth) return;
        const button = this.buttons[this.index];
        const navBox = this.nav.getBoundingClientRect();
        const box = button.getBoundingClientRect();
        const delta = box.left + box.width / 2 - (navBox.left + navBox.width / 2);
        this.nav.scrollBy({ left: delta, behavior: reduced() ? 'auto' : 'smooth' });
      }
    }

    customElements.get('timeline-slider') || customElements.define('timeline-slider', ContentTimeline);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadScript = (src) => new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) return existing.dataset.loaded ? resolve() : existing.addEventListener('load', () => resolve());
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => { script.dataset.loaded = 'true'; resolve(); };
      script.onerror = reject;
      document.head.append(script);
    });

    class VideoBand extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('autoplay')) {
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.start(true);
          });
          this.observer.observe(this);
        } else {
          this.addEventListener('click', () => this.start(false), { once: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      get video() {
        const phone = matchMedia('(max-width: 699px)').matches;
        return (phone && this.querySelector('video[data-mobile]')) || this.querySelector('video:not([data-mobile])');
      }

      start(muted) {
        if (this.started) return;
        this.started = true;
        const provider = this.dataset.provider;
        if (provider) return this.embed(provider, muted || !matchMedia('(min-width: 1000px)').matches);
        const video = this.video;
        if (!video) return;
        const controls = this.hasAttribute('data-controls');
        video.muted = muted;
        if (muted) {
          video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
        } else {
          this.classList.add('is-playing');
          if (controls) video.controls = true;
        }
        video.play().catch(() => {
          if (muted) return;
          video.controls = true;
          if (!controls) video.addEventListener('play', () => (video.controls = false), { once: true });
        });
      }

      async embed(provider, muted) {
        const autoplay = this.hasAttribute('autoplay');
        const id = this.dataset.videoId;
        const media = this.querySelector('.video-band__media');
        const host = document.createElement('div');
        media.prepend(host);
        const shown = () => this.classList.add('is-playing');
        if (!autoplay) shown();
        try {
          if (provider === 'youtube') {
            await loadScript('https://www.youtube.com/iframe_api');
            await new Promise((resolve) => {
              if (window.YT?.Player) return resolve();
              const previous = window.onYouTubeIframeAPIReady;
              window.onYouTubeIframeAPIReady = () => { previous?.(); resolve(); };
            });
            const playerVars = { autoplay: 1, mute: muted ? 1 : 0, playsinline: 1, rel: 0, modestbranding: 1 };
            if (autoplay) Object.assign(playerVars, { controls: 0, loop: 1, playlist: id });
            new window.YT.Player(host, {
              videoId: id,
              playerVars,
              events: {
                onReady: (event) => {
                  if (muted) event.target.mute();
                  event.target.playVideo();
                  shown();
                },
              },
            });
          } else {
            await loadScript('https://player.vimeo.com/api/player.js');
            const options = { id, autoplay: true, muted, title: false, byline: false, portrait: false, color: this.dataset.color, playsinline: true };
            if (autoplay) Object.assign(options, { background: true, loop: true });
            const player = new window.Vimeo.Player(host, options);
            await player.ready();
            shown();
            player.play().catch(() => {});
          }
        } catch (error) {
          this.started = false;
          host.remove();
        }
      }
    }

    customElements.get('video-band') || customElements.define('video-band', VideoBand);
  })();

  } catch(e) { console.error(e); }
})();
})();
